<template>
<div class="MReportIndex" :style="{padding: showAppTips ? '1.98rem 0 0' : '0.88rem 0 0'}">
    <MHeader></MHeader>
    <div class="m-body">
        <MBanner></MBanner>
        <mReportContent></mReportContent>
    </div>
    <transition name="slide-fade">
        <div class="gotop icon-gotop" @click="goTop" v-if="show"></div>
    </transition>
    <!-- <MTab></MTab> -->
</div>
</template>

<script>
import MBanner from 'views/reportMobile/index/components/mBanner'
import mReportContent from 'views/reportMobile/index/components/mReportContent'
// import MTab from 'views/reportMobile/components/tab/mTab'
// import MTab from 'views/mobile/components/tab/mTab'
import MHeader from 'views/mobile/components/mheader/mHeader'
import {getWXSDKSetting} from 'common/js/wxSDKSetting'
import {mapGetters} from 'vuex'
import $ from 'jquery'
export default {
    name: 'MReportIndex',
    // metaInfo: {
    //   title: '精品投研'
    // },
    data() {
        return {
            show: false
        }
    },
    created() {
        // console.log('this.domainInfo.isMobile',this.domainInfo)
        if(!this.domainInfo.isMobile){
            this.$router.push({
                name: 'PRHome'
            })
        }
    },
    activated() {
        $('html,body').animate({scrollTop:'0px'},0)
    },
    mounted() {
        if (this._isWixin()) {
            let link = window.location.protocol + '//' + window.location.host + window.location.pathname
            getWXSDKSetting({
                title: '精品投研 | 发现数据价值-鲸融网',
                desc: '精品投研是是一个专注于互联网数据研究、互联网数据调研、IT数据分析、互联网咨询机构数据、互联网权威机构，是拥有超过300个细分行业的精品研究报告供您查阅，课件、笔记、论文、文档等多种形式资料分享，打造商业人群共享的专业智库平台。',
                link: link,
                imgUrl: 'http://img.capwhale.com/capwhale_logo.png'
            })
        }
        let _this = this
        $(window).scroll(function () {
            let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            let clientHeight = document.body.clientHeight / 2
            if(scrollTop >= clientHeight){
                _this.show = true
            }
            else{
                _this.show = false
            }
        })
    },
    methods: {
        _isWixin() {
            let ua = window.navigator.userAgent.toLowerCase()
            if (/micromessenger/.test(ua)) {
                return true
            } else {
                return false
            }
        },
        goTop() {
            $('html,body').animate({scrollTop:'0px'},300)
            // document.body.scrollTop = document.documentElement.scrollTop = 0;
        }
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['domainInfo', 'showAppTips'])
    },
    components: {
        MBanner,
        mReportContent,
        MHeader
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.MReportIndex {
    position: relative;
    padding: 0.88rem 0 0;
    // padding-bottom: 1.08rem;
    // .m-body{
    //     background-color: pink;
    // }
    .gotop{
        position: fixed;
        right: 0.4rem;
        bottom: 1.76rem;
        width: 0.88rem;
        height: 0.88rem;
        opacity: 1;
    }
    .slide-fade-enter-active, .slide-fade-leave-active {
        transition: all .3s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to{
        opacity: 0;
    }
}
</style>